(function () {
  const root = document.querySelector('[data-supra-cart]');
  if (!root) return;

  const body = root.querySelector('[data-supra-cart-body]');
  const footer = root.querySelector('[data-supra-cart-footer]');
  const countEl = root.querySelector('[data-supra-cart-count]');
  const note = root.querySelector('[data-supra-cart-subscription-note]');
  const shippingText = root.querySelector('[data-supra-cart-shipping-text]');
  const shippingProgress = root.querySelector('[data-supra-cart-shipping-progress]');
  const totalEl = root.querySelector('[data-supra-cart-total]');
  const checkoutTotalEl = root.querySelector('[data-supra-cart-checkout-total]');
  const originalTotalEl = root.querySelector('[data-supra-cart-original-total]');
  const savingsEl = root.querySelector('[data-supra-cart-savings]');
  const savingsBanner = root.querySelector('[data-supra-cart-savings-banner]');
  const initialJson = root.querySelector('[data-supra-cart-json]');
  const emptyUrl = root.dataset.emptyUrl || '/collections/all';
  const subscriptionOptions = [
    {
      key: '30',
      label: '1 Month',
      detail: '30 Sachets',
      cartLabel: '30 Sachets Every Month',
      delivery: 'Deliver every 30 days',
      discount: '10% OFF',
      variantId: 55296426180956,
      sellingPlanId: 692152009052,
    },
    {
      key: '60',
      label: '2 Month',
      detail: '60 Sachets',
      cartLabel: '60 Sachets Every 2 Months',
      delivery: 'Deliver every 60 days',
      discount: '20% OFF',
      variantId: 56985252626780,
      sellingPlanId: 692437090652,
    },
    {
      key: '90',
      label: '3 Month',
      detail: '90 Sachets',
      cartLabel: '90 Sachets Every 3 Months',
      delivery: 'Deliver every 90 days',
      discount: '30% OFF',
      variantId: 55296426246492,
      sellingPlanId: 692152369500,
    },
  ];
  const subscriptionOptionsByVariant = new Map(subscriptionOptions.map((option) => [String(option.variantId), option]));
  const subscriptionOptionsByPlan = new Map(subscriptionOptions.map((option) => [String(option.sellingPlanId), option]));
  let cart = parseInitialCart();
  let isRefreshing = false;
  let updatingLine = null;
  let updatingPlanKey = null;
  let closeTimer = null;
  const productCache = new Map();

  function parseInitialCart() {
    try {
      return JSON.parse(initialJson?.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function currencyCode() {
    return window.Shopify?.currency?.active || document.documentElement.dataset.currency || 'EUR';
  }

  function formatMoney(cents) {
    const value = (Number(cents) || 0) / 100;
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode(),
      minimumFractionDigits: value % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function logoMarkup() {
    return `
      <img
        class="supra-cart__mark"
        src="https://cdn.shopify.com/s/files/1/0945/8955/0940/files/supra-logo-icon-black.svg?v=1772814273"
        alt=""
        loading="lazy"
      >
    `;
  }

  function hasSubscriptionItems() {
    return Array.isArray(cart.items) && cart.items.some((item) => item.selling_plan_allocation);
  }

  function itemOriginalLinePrice(item) {
    const compareAt = item.variant?.compare_at_price || item.compare_at_price || item._variant_compare_at_price;
    if (compareAt && compareAt > item.original_price) {
      return compareAt * item.quantity;
    }

    return item.original_line_price || item.original_price * item.quantity;
  }

  function itemFinalLinePrice(item) {
    return item.final_line_price ?? item.line_price ?? item.price * item.quantity;
  }

  function cartOriginalTotal() {
    return (cart.items || []).reduce((sum, item) => sum + itemOriginalLinePrice(item), 0);
  }

  function variantText(item) {
    if (item.variant_title && item.variant_title !== 'Default Title') return item.variant_title;
    if (Array.isArray(item.options_with_values) && item.options_with_values.length) {
      return item.options_with_values.map((option) => option.value).join(', ');
    }
    return '';
  }

  function sellingPlanText(item) {
    return item.selling_plan_allocation?.selling_plan?.name || '';
  }

  function deliveryText(item) {
    return sellingPlanText(item) || 'Delivered once';
  }

  function updateShippingProgress(count) {
    const hasSubscription = hasSubscriptionItems();

    note.hidden = !count;
    if (!count) return;

    shippingText.textContent = hasSubscription
      ? 'You have unlocked free shipping.'
      : 'Upgrade to subscription to unlock free shipping.';
    shippingProgress.style.width = hasSubscription ? '100%' : '42%';
    note.classList.toggle('is-unlocked', hasSubscription);
  }

  function productHandleForItem(item) {
    if (item.handle) return item.handle;
    const url = item.url || item.product_url || '';
    return url.split('/products/')[1]?.split(/[/?#]/)[0] || '';
  }

  async function productDataForHandle(handle) {
    if (!handle) return null;
    if (productCache.has(handle)) return productCache.get(handle);

    const productPromise = fetch(`/products/${handle}.js`, {
      credentials: 'same-origin',
      cache: 'force-cache',
    })
      .then((response) => (response.ok ? response.json() : null))
      .catch(() => null);

    productCache.set(handle, productPromise);
    return productPromise;
  }

  async function hydrateVariantCompareAtPrices(cartData) {
    const items = cartData.items || [];
    await Promise.all(
      items.map(async (item) => {
        if (item._variant_compare_at_price || item.variant?.compare_at_price || item.compare_at_price) return;

        const productData = await productDataForHandle(productHandleForItem(item));
        const variant = productData?.variants?.find((entry) => Number(entry.id) === Number(item.variant_id));
        if (variant?.compare_at_price) {
          item._variant_compare_at_price = Number(variant.compare_at_price);
        }
      })
    );
  }

  function subscriptionOptionForItem(item) {
    if (!item) return null;

    const planId = item.selling_plan_allocation?.selling_plan?.id;
    return subscriptionOptionsByPlan.get(String(planId)) || subscriptionOptionsByVariant.get(String(item.variant_id));
  }

  function isSubscriptionItem(item) {
    return Boolean(item.selling_plan_allocation);
  }

  function subscriptionControlsMarkup(item, index) {
    const currentOption = subscriptionOptionForItem(item);
    if (!currentOption) return '';

    const isUpdating = updatingLine === index + 1;
    const loadingMarkup = isUpdating
      ? '<span class="supra-cart__loading" aria-hidden="true"></span><span class="visually-hidden">Updating cart</span>'
      : '';

    if (!isSubscriptionItem(item)) {
      return `
        <div class="supra-cart__subscription ${isUpdating ? 'is-loading' : ''}" data-subscription-controls aria-busy="${isUpdating ? 'true' : 'false'}">
          <button class="supra-cart__subscribe-button" type="button" data-supra-cart-subscribe="${index + 1}" ${isUpdating ? 'disabled' : ''}>
            ${loadingMarkup}
            <span>Subscribe &amp; Save up to 30%</span>
          </button>
        </div>
      `;
    }

    const optionButtons = subscriptionOptions
      .map((option) => {
        const isActive = option.variantId === Number(item.variant_id);
        const isChosenPlan = updatingPlanKey === option.key;
        const discountMarkup =
          isUpdating && isChosenPlan
            ? '<span class="supra-cart__loading supra-cart__plan-loader" aria-hidden="true"></span><span class="visually-hidden">Updating cart</span>'
            : `<strong>${option.discount}</strong>`;

        return `
          <button
            class="supra-cart__plan ${isActive ? 'is-active' : ''}"
            type="button"
            data-supra-cart-plan="${option.key}"
            aria-pressed="${isActive ? 'true' : 'false'}"
            ${isUpdating ? 'disabled' : ''}
          >
            <span class="supra-cart__plan-radio" aria-hidden="true"></span>
              <span class="supra-cart__plan-copy">
              <span class="supra-cart__plan-title">${option.cartLabel}</span>
            </span>
            ${discountMarkup}
          </button>
        `;
      })
      .join('');

    return `
      <div class="supra-cart__subscription" data-subscription-controls>
        <div class="supra-cart__subscription-top">
          <span>Subscribe &amp; Save up to 30%</span>
          <button
            class="supra-cart__toggle is-on"
            type="button"
            role="switch"
            aria-checked="true"
            data-supra-cart-one-time="${index + 1}"
            ${isUpdating ? 'disabled' : ''}
          >
            <span></span>
          </button>
        </div>
        <div class="supra-cart__plans ${isUpdating ? 'is-loading' : ''}" aria-busy="${isUpdating ? 'true' : 'false'}">
          ${optionButtons}
        </div>
        <div class="supra-cart__commitment">
          <span class="supra-cart__commitment-icon" aria-hidden="true">
            <svg viewBox="0 0 256 256" focusable="false">
              <path d="M128 24a104 104 0 1 0 104 104A104.1 104.1 0 0 0 128 24Zm0 192a88 88 0 1 1 88-88 88.1 88.1 0 0 1-88 88ZM112 96v64a8 8 0 0 1-16 0V96a8 8 0 0 1 16 0Zm48 0v64a8 8 0 0 1-16 0V96a8 8 0 0 1 16 0Z" fill="currentColor"/>
            </svg>
          </span>
          <span>No commitment, modify or cancel any time.</span>
        </div>
      </div>
    `;
  }

  function renderEmpty() {
    body.innerHTML = `
      <div class="supra-cart__empty">
        <div class="supra-cart__empty-inner">
          ${logoMarkup()}
          <p>Your cart is empty.</p>
          <a class="supra-cart__empty-button" href="${escapeHtml(emptyUrl)}">GET STARTED</a>
        </div>
      </div>
    `;
  }

  function renderItems() {
    body.innerHTML = (cart.items || [])
      .map((item, index) => {
        const original = itemOriginalLinePrice(item);
        const final = itemFinalLinePrice(item);
        const savings = Math.max(original - final, 0);
        const variant = variantText(item);
        const sellingPlan = deliveryText(item);
        const image = item.image
          ? `<img class="supra-cart__image" src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">`
          : logoMarkup();

        return `
          <article class="supra-cart__item" data-line="${index + 1}">
            <a class="supra-cart__image-link" href="${escapeHtml(item.url)}">${image}</a>
            <a class="supra-cart__item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
            <button class="supra-cart__remove" type="button" aria-label="Remove ${escapeHtml(item.product_title)}" data-supra-cart-remove>&times;</button>
            ${variant ? `<p class="supra-cart__meta supra-cart__variant">${escapeHtml(variant)}</p>` : ''}
            ${sellingPlan ? `<p class="supra-cart__meta supra-cart__selling-plan">${escapeHtml(sellingPlan)}</p>` : ''}
            <div class="supra-cart__quantity" aria-label="Quantity">
              <button type="button" data-supra-cart-quantity="-1" aria-label="Decrease quantity">-</button>
              <span>${item.quantity}</span>
              <button type="button" data-supra-cart-quantity="1" aria-label="Increase quantity">+</button>
            </div>
            <div class="supra-cart__line-price">
              ${savings > 0 ? `<s>${formatMoney(original)}</s> ` : ''}
              <span>${formatMoney(final)}</span>
              ${savings > 0 ? `<span class="supra-cart__line-saving">Save ${formatMoney(savings)}</span>` : ''}
            </div>
            ${subscriptionControlsMarkup(item, index)}
          </article>
        `;
      })
      .join('');
  }

  function syncHeaderCount() {
    document.querySelectorAll('.cart-bubble__text-count').forEach((el) => {
      el.textContent = cart.item_count ? String(cart.item_count) : '';
      el.classList.toggle('hidden', !cart.item_count);
    });

    document.querySelectorAll('.cart-bubble').forEach((el) => {
      el.classList.toggle('visually-hidden', !cart.item_count);
    });

    document.querySelectorAll('cart-icon').forEach((el) => {
      el.classList.toggle('header-actions__cart-icon--has-cart', Boolean(cart.item_count));
    });

    document.querySelectorAll('[data-instant-dynamic-content-source="CART_COUNT"]').forEach((el) => {
      el.textContent = String(cart.item_count || 0);
      el.hidden = !cart.item_count;
      el.classList.toggle('hidden', !cart.item_count);
      el.classList.toggle('is-hidden', !cart.item_count);
      el.setAttribute('aria-hidden', cart.item_count ? 'false' : 'true');
    });
  }

  function render() {
    const count = cart.item_count || 0;
    countEl.textContent = count ? String(count) : '';
    footer.hidden = !count;
    updateShippingProgress(count);

    if (!count) {
      renderEmpty();
    } else {
      renderItems();
      const originalTotal = cartOriginalTotal();
      const finalTotal = cart.total_price || 0;
      const savings = Math.max(originalTotal - finalTotal, 0);

      totalEl.textContent = formatMoney(finalTotal);
      if (checkoutTotalEl) checkoutTotalEl.textContent = formatMoney(finalTotal);
      originalTotalEl.hidden = !savings;
      originalTotalEl.textContent = savings ? formatMoney(originalTotal) : '';
      savingsBanner.hidden = !savings;
      savingsEl.textContent = savings ? `You're saving ${formatMoney(savings)}.` : '';
    }

    syncHeaderCount();
  }

  function normalizeInstantCartLinks() {
    document.querySelectorAll('[data-instant-action-type="add-to-cart"][href]').forEach((link) => {
      const variantId = link.getAttribute('data-instant-action-variant-id');
      if (!variantId) return;

      const url = new URL(link.getAttribute('href'), window.location.origin);
      const currentQuantity = url.pathname.match(/\/cart\/\d+:(\d+)/)?.[1] || '1';
      const normalizedHref = `/cart/${variantId}:${currentQuantity}?storefront=true`;

      if (link.getAttribute('href') !== normalizedHref) {
        link.setAttribute('href', normalizedHref);
      }
    });
  }

  function instantFormForTrigger(trigger) {
    return trigger.closest('[data-instant-form-product-id], form[data-instant-type="root"], [data-instant-type="root"]');
  }

  function parseInstantQuantity(trigger) {
    try {
      const url = new URL(trigger.getAttribute('href') || '', window.location.origin);
      return Number(url.pathname.match(/\/cart\/\d+:(\d+)/)?.[1]) || 1;
    } catch (error) {
      return 1;
    }
  }

  function instantVariantIdForTrigger(trigger) {
    return (
      trigger.getAttribute('data-instant-action-variant-id') ||
      instantFormForTrigger(trigger)?.getAttribute('data-instant-form-variant-id') ||
      ''
    );
  }

  function normalizeSellingPlanId(value) {
    if (!value || value === 'one-time-purchase') return '';
    return value;
  }

  function instantSellingPlanIdForTrigger(trigger) {
    const directPlan = normalizeSellingPlanId(
      trigger.getAttribute('data-instant-action-selling-plan-id') ||
        trigger.getAttribute('data-selling-plan-id') ||
        trigger.getAttribute('selling-plan-id')
    );
    if (directPlan) return directPlan;

    const form = instantFormForTrigger(trigger);
    const activePlan = form?.querySelector(
      '[data-instant-action-type="select-selling-plan"][data-instant-state="active"], [data-instant-action-type="select-selling-plan"][aria-pressed="true"], [data-instant-action-type="select-selling-plan"].is-active'
    );
    const activePlanId = normalizeSellingPlanId(activePlan?.getAttribute('data-instant-selling-plan-id'));
    if (activePlanId || activePlan?.getAttribute('data-instant-selling-plan-id') === 'one-time-purchase') return activePlanId;

    return normalizeSellingPlanId(form?.getAttribute('data-instant-form-selling-plan-id'));
  }

  async function refreshCart() {
    if (isRefreshing) return cart;
    isRefreshing = true;

    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
      });
      cart = await response.json();
      await hydrateVariantCompareAtPrices(cart);
      render();
      return cart;
    } finally {
      isRefreshing = false;
    }
  }

  async function changeLine(line, quantity, options = {}) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ line, quantity }),
    });
    cart = await response.json();
    if (options.hydrate !== false) await hydrateVariantCompareAtPrices(cart);
    if (options.render !== false) render();
  }

  async function addLine({ variantId, quantity, sellingPlanId }) {
    const item = {
      id: Number(variantId),
      quantity,
    };

    if (sellingPlanId) item.selling_plan = Number(sellingPlanId);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: [item] }),
    });

    if (!response.ok) throw new Error('Unable to add subscription option');
  }

  async function replaceLine(line, option, subscribe) {
    const item = cart.items?.[line - 1];
    if (!item || !option) return;

    updatingLine = line;
    updatingPlanKey = subscribe ? option.key : 'one-time';
    render();

    try {
      await changeLine(line, 0, { hydrate: false, render: false });
      await addLine({
        variantId: option.variantId,
        quantity: item.quantity,
        sellingPlanId: subscribe ? option.sellingPlanId : null,
      });
      await refreshCart();
    } finally {
      updatingLine = null;
      updatingPlanKey = null;
      render();
    }
  }

  function openCart() {
    clearTimeout(closeTimer);
    root.classList.remove('is-closing');
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('supra-cart-open');
    root.querySelector('.supra-cart__drawer')?.focus();
  }

  function closeCart() {
    if (!root.classList.contains('is-open')) return;

    clearTimeout(closeTimer);
    root.classList.remove('is-open');
    root.classList.add('is-closing');
    root.setAttribute('aria-hidden', 'true');
    closeTimer = setTimeout(() => {
      root.classList.remove('is-closing');
      document.body.classList.remove('supra-cart-open');
    }, 240);
  }

  async function refreshAndOpen() {
    await refreshCart();
    openCart();
  }

  root.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (target.closest('[data-supra-cart-close]')) {
      closeCart();
      return;
    }

    const item = target.closest('[data-line]');
    if (!item) return;

    const line = Number(item.dataset.line);
    const current = cart.items?.[line - 1]?.quantity || 0;

    if (target.closest('[data-supra-cart-remove]')) {
      changeLine(line, 0);
      return;
    }

    const subscribeButton = target.closest('[data-supra-cart-subscribe]');
    if (subscribeButton) {
      const option = subscriptionOptionForItem(cart.items?.[line - 1]);
      replaceLine(line, option, true);
      return;
    }

    if (target.closest('[data-supra-cart-one-time]')) {
      const option = subscriptionOptionForItem(cart.items?.[line - 1]);
      replaceLine(line, option, false);
      return;
    }

    const planButton = target.closest('[data-supra-cart-plan]');
    if (planButton) {
      const option = subscriptionOptions.find((entry) => entry.key === planButton.dataset.supraCartPlan);
      replaceLine(line, option, true);
      return;
    }

    const quantityButton = target.closest('[data-supra-cart-quantity]');
    if (quantityButton) {
      const delta = Number(quantityButton.dataset.supraCartQuantity);
      changeLine(line, Math.max(current + delta, 0));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && root.classList.contains('is-open')) closeCart();
  });

  normalizeInstantCartLinks();

  let instantLinkObserverTimer;
  const scheduleInstantLinkNormalization = () => {
    clearTimeout(instantLinkObserverTimer);
    instantLinkObserverTimer = setTimeout(normalizeInstantCartLinks, 50);
  };

  const instantLinkObserver = new MutationObserver(scheduleInstantLinkNormalization);
  instantLinkObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  document.addEventListener(
    'click',
    async (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const trigger = target.closest('[data-instant-action-type="add-to-cart"]');
      if (!trigger || root.contains(trigger)) return;

      const variantId = instantVariantIdForTrigger(trigger);
      if (!variantId) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const sellingPlanId = instantSellingPlanIdForTrigger(trigger);
      trigger.setAttribute('aria-busy', 'true');

      try {
        await addLine({
          variantId,
          quantity: parseInstantQuantity(trigger),
          sellingPlanId,
        });
        document.dispatchEvent(
          new CustomEvent('instant:add-to-cart', {
            detail: { variantId, sellingPlanId },
          })
        );
      } catch (error) {
        console.error(error);
      } finally {
        trigger.removeAttribute('aria-busy');
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const trigger = target.closest(
        'a[href="/cart"], a[href*="/cart"], button[data-testid="cart-drawer-trigger"], [data-instant-action-type*="cart"]'
      );

      if (!trigger || root.contains(trigger)) return;

      const href = trigger.getAttribute('href') || '';
      const actionType = trigger.getAttribute('data-instant-action-type') || '';
      if (actionType === 'add-to-cart') return;

      const isCartTrigger =
        actionType.includes('cart') ||
        href === '/cart' ||
        href.endsWith('/cart') ||
        href.includes('/cart?');

      if (!isCartTrigger) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      refreshAndOpen();
    },
    true
  );

  document.addEventListener('instant:add-to-cart', (event) => {
    event.stopPropagation();
    event.stopImmediatePropagation();
    setTimeout(refreshAndOpen, 250);
  }, true);

  ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxProduct:added', 'ajaxProduct:updated'].forEach((eventName) => {
    document.addEventListener(eventName, refreshCart);
  });

  window.openCartDrawer = refreshAndOpen;
  window.SUPRA_CART_DRAWER = {
    open: refreshAndOpen,
    close: closeCart,
    refresh: refreshCart,
  };

  render();
  hydrateVariantCompareAtPrices(cart).then(() => render());
})();
